import React from 'react';
import AppNotFound from './components';

const NotFound = () => {
    return (
        <AppNotFound />
    );
};

export default NotFound;
